import React from 'react';
import styled from 'styled-components';
import { IconAlertTriangle } from '@tabler/icons-react';

import { TotemButton } from 'ui/Button';

import { colors } from 'styles/theme';

// Message d'erreur cantonné à la section facturation : les infos viennent d'Odoo, donc elles peuvent
// manquer alors que tout le reste de l'app fonctionne. On n'affiche JAMAIS un formulaire vide dans ce
// cas — une sauvegarde écraserait les vraies valeurs côté Odoo par des champs vides.
export const BillingInfoUnavailable: React.FC<{ onRetry?: () => void }> = ({ onRetry }) => (
    <Container data-test="billing-info-unavailable">
        <Message>
            <IconAlertTriangle size={20} color={colors.lightRed} />
            <span>
                Les informations de facturation sont momentanément indisponibles. Le reste de votre espace fonctionne
                normalement, réessayez dans quelques instants.
            </span>
        </Message>
        {onRetry && (
            <TotemButton $type="secondary" $fontSize="1em" $margins={[0.5, 0]} onClick={onRetry}>
                Réessayer
            </TotemButton>
        )}
    </Container>
);

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5em;
    width: 100%;
`;

const Message = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5em;
    color: ${colors.lightRed};
    font-size: 0.9em;
`;
